import SmartToyIcon from '@mui/icons-material/SmartToy';
import SportsIcon from '@mui/icons-material/Sports';
import { Box, Card, Theme, Typography } from '@mui/material';
import { ShowView, useTranslate } from 'react-admin';

import { ExternalLink } from '@sh4res/bo-common/components/ExternalLink';
import { PageTitle } from '@sh4res/bo-common/components/PageTitle';

const styles = {
  card: {
    margin: '2px 2px 15px 2px',
  },
  header: {
    display: 'flex',
    justifyContent: 'flex-start',
    columnGap: '8px',
    padding: '13px 15px',
    fontWeight: 600,
  },
  section: {
    margin: '0 0 15px 0',
  },
  grid: (theme: Theme) => ({
    display: 'grid',
    gridTemplateColumns: '34% 66%',
    borderBottom: 'none',
    '& .RaImageField-image': { verticalAlign: 'middle' },
    '& .MuiTypography-root': {
      fontSize: theme.typography.body1,
      margin: 0,
    },
  }),
  rowCell: {
    padding: '13px 15px',
    borderTop: '1px solid #E8E8E8',
    alignContent: 'center',
    overflow: 'auto',
  },
};

export const Services = () => {
  const translate = useTranslate();
  const translatedTitle = translate('resources.bo_common.services_page.title');

  const title = (
    <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '17px', margin: 0 }}>
      {translatedTitle}
    </Typography>
  );

  return (
    <>
      <PageTitle title={translatedTitle} />
      <ShowView title={title} component={Box}>
        <Card sx={styles.section}>
          <Box sx={styles.header}>
            <SportsIcon />
            <Box>{translate('resources.bo_common.services_page.savings_coach.title')}</Box>
          </Box>
          <Box sx={styles.grid}>
            <Box sx={styles.rowCell}>
              <Typography>Description</Typography>
            </Box>
            <Box sx={styles.rowCell}>
              {translate('resources.bo_common.services_page.savings_coach.description')}
            </Box>
            <Box sx={styles.rowCell}>
              <Typography>Link</Typography>
            </Box>
            <Box sx={styles.rowCell}>
              <ExternalLink
                href="https://filib.fr/"
                sx={{ textDecoration: 'none', color: 'primary.main' }}>
                https://filib.fr/
              </ExternalLink>
            </Box>
          </Box>
        </Card>

        <Card sx={styles.section}>
          <Box sx={styles.header}>
            <SmartToyIcon />
            <Box>{translate('resources.bo_common.services_page.robot_advisor.title')}</Box>
          </Box>
          <Box sx={styles.grid}>
            <Box sx={styles.rowCell}>
              <Typography>Description</Typography>
            </Box>
            <Box sx={styles.rowCell}>
              {translate('resources.bo_common.services_page.robot_advisor.description')}
            </Box>
          </Box>
        </Card>
      </ShowView>
    </>
  );
};
